import { render, staticRenderFns } from "./AnalyticsPerformance.vue?vue&type=template&id=84623500&"
import script from "./AnalyticsPerformance.vue?vue&type=script&lang=js&"
export * from "./AnalyticsPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports